import React from "react";
import { withTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

const TimelineErrorState = ({ t, onRetry }) => (
  <div className="mat-error-state" data-testid="mat-error-state">
    <p>{t("MetricAnomalyTimeline.loadError.label")}</p>
    <Button variant="primary" size="sm" onClick={onRetry}>
      {t("MetricAnomalyTimeline.retry.label")}
    </Button>
  </div>
);

export default withTranslation()(TimelineErrorState);
